import React from 'react'
import './index.css'

type Props = { small?: boolean }
const LoadingSpinner: React.FC<Props> = (props: Props) => (
  <div className={'LoadingSpinner' + (props.small ? ' small' : '')}></div>
)

export default LoadingSpinner
